module.exports = __webpack_public_path__ + "static/img/s-local-1.267326f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/clac/img/s-local-1.png
// module id = OT6W
// module chunks = 1